/**
 * 四捨五入（PHP の round() と同じ「0から遠い方へ」丸める）
 *
 * JS の Math.round は端数がちょうど0.5のとき常に+∞方向に丸めるため、
 * マイナス値では PHP の round()（0から遠い方へ丸める）と結果が1ずれる。
 *   例) -2984.5 → JS Math.round = -2984 / PHP round = -2985
 * ※ Math.floor / Math.ceil は元々 PHP の floor() / ceil() と一致するため対象外。
 */
window.roundHalfAwayFromZero = function (value) {
    return value < 0 ? -Math.round(-value) : Math.round(value);
}
